import { canv } from "@/canv/global";
import styles from "./AddFirstPresentation.module.scss";
import { AddFirstPresentationItem } from "./AddFirstPresentationItem";
import { ITEMS } from "./constants";

export const AddFirstPresentation = () => {
    return (
        <div className={styles.addFirstSlide}>
            <p className={styles.addFirstSlideTitle}>Создайте презентацию</p>
            {ITEMS.map((item) => (
                <AddFirstPresentationItem
                    key={item.src}
                    src={`${canv.host}${item.src}`}
                    text={item.text}
                />
            ))}
        </div>
    );
};
